(function () {
  var scrollThreshold = 100;
  var mobileBreakpoint = 992;

  function syncCartBadges(count) {
    var n = typeof count === "number" ? count : 0;
    document.querySelectorAll("[data-header-cart-count]").forEach(function (el) {
      el.textContent = String(n);
      el.classList.toggle("is-active", n > 0);
    });
  }

  function initCartBadges() {
    var els = document.querySelectorAll("[data-header-cart-count]");
    if (!els.length) return;
    var initial = parseInt(els[0].getAttribute("data-initial-count") || "0", 10) || 0;
    syncCartBadges(initial);
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var data = event && event.cartData;
        if (data && typeof data.item_count === "number") {
          syncCartBadges(data.item_count);
        }
      });
    }
  }

  function onScroll(headerEl) {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    headerEl.classList.toggle("header-scrolled", y > scrollThreshold);
  }

  function clearMobileDropdownState(headerEl, dropdownRoot) {
    if (dropdownRoot) dropdownRoot.classList.remove("is-visible");
    headerEl.querySelectorAll(".header__dropdown--linked").forEach(function (p) {
      p.classList.remove("is-active");
    });
    headerEl.querySelectorAll(".header__menu-item.dropdown-open").forEach(function (li) {
      li.classList.remove("dropdown-open");
    });
  }

  function resetMobileChrome(headerEl, toggle, nav, cart, container, logo, dropdownRoot) {
    toggle.classList.remove("active");
    nav.classList.remove("nav-open");
    if (cart) cart.classList.remove("cart-show");
    container.classList.remove("add-background");
    logo.classList.remove("logo-mob");
    toggle.setAttribute("aria-expanded", "false");
    clearMobileDropdownState(headerEl, dropdownRoot);
  }

  function bindMobileNav(headerEl) {
    var toggle = headerEl.querySelector(".header__mobile-toggle");
    var nav = headerEl.querySelector(".header__nav");
    var cart = headerEl.querySelector(".header__cart");
    var container = headerEl.querySelector(".header-container");
    var logo = headerEl.querySelector(".header__logo");
    var dropdownRoot = headerEl.querySelector(".header__dropdown");
    if (!toggle || !nav || !container || !logo) return;
    toggle.addEventListener("click", function () {
      var open = !nav.classList.contains("nav-open");
      toggle.classList.toggle("active");
      nav.classList.toggle("nav-open");
      if (cart) cart.classList.toggle("cart-show");
      container.classList.toggle("add-background");
      logo.classList.toggle("logo-mob");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (!open) {
        resetMobileChrome(headerEl, toggle, nav, cart, container, logo, dropdownRoot);
      }
    });
  }

  function bindMobileDropdownTaps(headerEl) {
    var dropdownRoot = headerEl.querySelector(".header__dropdown");
    var items = headerEl.querySelectorAll(".header__menu-item[data-block-id]");
    items.forEach(function (li) {
      var id = li.getAttribute("data-block-id");
      if (!id) return;
      var panel = headerEl.querySelector('.header__dropdown--linked[data-parent-id="' + id + '"]');
      if (!panel) return;
      var link = li.querySelector(".header__menu-link");
      if (!link) return;
      link.addEventListener("click", function (e) {
        if (window.innerWidth > mobileBreakpoint) return;
        e.preventDefault();
        var wasOpen = li.classList.contains("dropdown-open");
        items.forEach(function (x) {
          x.classList.remove("dropdown-open");
        });
        if (wasOpen) {
          if (dropdownRoot) dropdownRoot.classList.remove("is-visible");
          panel.classList.remove("is-active");
        } else {
          li.classList.add("dropdown-open");
          if (dropdownRoot) dropdownRoot.classList.add("is-visible");
          headerEl.querySelectorAll(".header__dropdown--linked").forEach(function (p) {
            p.classList.remove("is-active");
          });
          panel.classList.add("is-active");
        }
      });
    });
  }

  function bindNavLinkClose(headerEl) {
    var nav = headerEl.querySelector(".header__nav");
    var dropdownRoot = headerEl.querySelector(".header__dropdown");
    if (!nav) return;
    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        if (window.innerWidth > mobileBreakpoint) return;
        var toggle = headerEl.querySelector(".header__mobile-toggle");
        var navEl = headerEl.querySelector(".header__nav");
        var cart = headerEl.querySelector(".header__cart");
        var container = headerEl.querySelector(".header-container");
        var logo = headerEl.querySelector(".header__logo");
        if (!toggle || !navEl || !navEl.classList.contains("nav-open")) return;
        if (link.closest(".header__dropdown")) return;
        var li = link.closest(".header__menu-item");
        var bid = li && li.getAttribute("data-block-id");
        if (bid && headerEl.querySelector('.header__dropdown--linked[data-parent-id="' + bid + '"]')) return;
        resetMobileChrome(headerEl, toggle, navEl, cart, container, logo, dropdownRoot);
      });
    });
  }

  function boot() {
    var headerEl = document.getElementById("header");
    if (!headerEl) return;
    var dropdownRoot = headerEl.querySelector(".header__dropdown");
    var resizeTimer = null;
    var wasMobile = window.innerWidth <= mobileBreakpoint;
    var onViewportResize = function () {
      var w = window.innerWidth;
      var isMobile = w <= mobileBreakpoint;
      if (wasMobile === isMobile) return;
      wasMobile = isMobile;
      var dr = headerEl.querySelector(".header__dropdown");
      var nav = headerEl.querySelector(".header__nav");
      var toggle = headerEl.querySelector(".header__mobile-toggle");
      clearMobileDropdownState(headerEl, dr);
      if (!isMobile && nav && toggle && nav.classList.contains("nav-open")) {
        var cart = headerEl.querySelector(".header__cart");
        var container = headerEl.querySelector(".header-container");
        var logo = headerEl.querySelector(".header__logo");
        resetMobileChrome(headerEl, toggle, nav, cart, container, logo, dr);
      }
    };
    window.addEventListener("resize", function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onViewportResize, 120);
    });
    bindMobileNav(headerEl);
    bindMobileDropdownTaps(headerEl);
    document.addEventListener("click", function (e) {
      if (headerEl.contains(e.target)) return;
      var toggle = headerEl.querySelector(".header__mobile-toggle");
      var nav = headerEl.querySelector(".header__nav");
      var cart = headerEl.querySelector(".header__cart");
      var container = headerEl.querySelector(".header-container");
      var logo = headerEl.querySelector(".header__logo");
      if (!toggle || !nav || !container || !logo) return;
      if (!nav.classList.contains("nav-open")) return;
      resetMobileChrome(headerEl, toggle, nav, cart, container, logo, dropdownRoot);
    });
    window.addEventListener(
      "scroll",
      function () {
        onScroll(headerEl);
      },
      { passive: true }
    );
    onScroll(headerEl);
    initCartBadges();
    bindNavLinkClose(headerEl);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
